import React from "react";
import "./MenuItems.css";
import { useCart } from "../Context/CartContext";

const MenuItems = ({ items }) => {
  const { cart, addToCart, increaseQty, decreaseQty } = useCart();

  if (!items || items.length === 0) {
    return (
      <p className="empty-text">
        Sorry no items available for this category
      </p>
    );
  }

  return (
    <div className="items-wrapper">
      <div className="items-grid">
        {items.map((item) => {
          const cartItem = cart[item.id];

          return (
            <div key={item.id} className="item-card">
              <img
                src={item.image_url}
                alt={item.name}
                className="item-image"
              />

              <div className="item-content">
                <h3 className="item-name">{item.name}</h3>

                <span className="price">
                  ₹ {item.final_price}
                </span>

                {item.is_veg && (
                  <span className="veg-badge">Veg</span>
                )}
              </div>

              {!cartItem ? (
                <button
                  className="add-btn"
                  onClick={() => addToCart(item)}
                >
                  Add
                </button>
              ) : (
                <div className="qty-controls">
                  <button
                    className="qty-btn"
                    onClick={() => decreaseQty(item.id)}
                  >
                    -
                  </button>

                  <span className="qty-count">
                    {cartItem.quantity}
                  </span>

                  <button
                    className="qty-btn"
                    onClick={() => increaseQty(item.id)}
                  >
                    +
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MenuItems;
